import { useEffect, useState } from "react";
import { ANPR_Detail } from "../../../graphql/models";
import { Button, TextField } from "@material-ui/core";

export interface BuildingGuestParkingCameraProps {
  devices: ANPR_Detail[];
  onChange: (items: ANPR_Detail[]) => void;
}

export interface BuildingGuestParkingCameraItemProps {
  device: ANPR_Detail;
  onChange: (item: ANPR_Detail) => void;
  onDelete?: () => void;
}

export function BuildingGuestParkingCameraItem(
  props: BuildingGuestParkingCameraItemProps
) {
  const [type, setType] = useState(props.device?.type ?? "HikVision");
  const [baseUrl, setBaseUrl] = useState(props.device?.baseUrl ?? "");
  const [username, setUsername] = useState(props.device?.username ?? "");
  const [password, setPassword] = useState(props.device?.password ?? "");
  const [channel, setChannel] = useState(props.device?.channel ?? "");

  useEffect(() => {
    props.onChange({
      type: type,
      baseUrl: baseUrl,
      username: username,
      password: password,
      channel: channel,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, baseUrl, username, password, channel]);
  return (
    <tr>
      <td>
        <TextField
          variant="outlined"
          value={type}
          onChange={(e) => setType(e.target.value)}
          disabled={true}
          style={{ width: "100%" }}
        ></TextField>
      </td>
      <td>
        <TextField
          variant="outlined"
          value={baseUrl}
          onChange={(e) => setBaseUrl(e.target.value)}
          style={{ width: "100%" }}
        ></TextField>
      </td>
      <td>
        <TextField
          variant="outlined"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          style={{ width: "100%" }}
        ></TextField>
      </td>
      <td>
        <TextField
          variant="outlined"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{ width: "100%" }}
        ></TextField>
      </td>
      <td>
        <TextField
          variant="outlined"
          value={channel}
          onChange={(e) => setChannel(e.target.value)}
          style={{ width: "100%" }}
        ></TextField>
      </td>
      <td>
        {props.onDelete && (
          <Button variant="outlined" onClick={props.onDelete}>
            Elimina
          </Button>
        )}
      </td>
    </tr>
  );
}

export function BuildingGuestParkingCamera(
  props: BuildingGuestParkingCameraProps
) {
  const [rows, setRows] = useState(props.devices ?? []);

  const addRow = () => {
    const newItem: ANPR_Detail = {
      type: "HikVision",
      baseUrl: "",
      username: "",
      password: "",
      channel: "",
    };
    const newArray = [...rows, newItem];
    setRows(newArray);
  };

  const removeRow = (index: number) => {
    const newArray = [...rows];
    newArray.splice(index, 1);
    setRows(newArray);
  };

  const updateRow = (item: ANPR_Detail, index: number) => {
    const newArray = [...rows];
    newArray[index] = item;
    setRows(newArray);
  };

  useEffect(() => {
    console.log(`emitting onChange() => rows is ${JSON.stringify(rows)}`);
    props.onChange(rows);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rows]);

  return (
    <fieldset style={{ borderRadius: "1rem" }}>
      <legend>Sezione Dispositivi</legend>
      <table cellPadding={1} cellSpacing={2}>
        <tr>
          <th>Fornitore</th>
          <th style={{ width: "30%" }}>Base URL</th>
          <th style={{ width: "20%" }}>Username</th>
          <th style={{ width: "20%" }}>Password</th>
          <th>Canale</th>
        </tr>
        {rows.length === 0 && (
          <tr>
            <td colSpan={5}>Nessuna camera inserita</td>
          </tr>
        )}
        {rows.length > 0 &&
          rows.map((item, index) => (
            <BuildingGuestParkingCameraItem
              key={`row_${index}`}
              device={item}
              onChange={(updatedItem) => updateRow(updatedItem, index)}
              onDelete={() => removeRow(index)}
            />
          ))}
        <tr>
          <td colSpan={5}>
            <Button variant="outlined" onClick={addRow}>
              Aggiungi dispositivo
            </Button>
          </td>
        </tr>
      </table>
    </fieldset>
  );
}
